import axios from "axios";
import { baseUrlApi } from "@/config";
import { Message } from "element-ui";
import { getToken } from "@/utils/cookies";
const Agent = require("agentkeepalive");
// const Qs = require('qs');
const keepAliveAgent = new Agent({
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: 60000,
  freeSocketTimeout: 30000 // free socket keepalive for 30 seconds
});
const service = axios.create({
  baseURL: baseUrlApi + "api/",
  timeout: 60000,
  httpsAgent: keepAliveAgent,
  headers: {}
  // transformRequest: [
  //   function(data, headers) {
  //     // Do whatever you want to transform the data
  //     return data;
  //   }
  // ]
  // transformResponse: [function(data) {
  //  // Do whatever you want to transform the data
  //  return data;
  // }],
  // `paramsSerializer` is an optional function in charge of serializing `params`
  // paramsSerializer: function(params) {
  //  return Qs.stringify(params, {arrayFormat: 'brackets'})
  // },
  // withCredentials: true // send cookies when cross-domain requests
});
// Request interceptors
service.interceptors.request.use(
  config => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (getToken()) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
// Response interceptors
service.interceptors.response.use(
  response => {
    // console.log("Response:", response)
    return response;
  },
  error => {
    if (!!error.isAxiosError && !error.response) {
      // window.location.href = `${baseUrl}session/signin`;
    } else {
      let response = error.response;
      if (response.status == 401) {
        Message({
          message: "Unauthorization Error",
          type: "error",
          duration: 5000
        });
        // window.location.href = `${baseUrl}session/signin`;
      } else {
        Message({
          message: response.data.Message,
          type: "error",
          duration: 5000
        });
      }
    }
    return Promise.reject(error);
  }
);
export default service;
//# sourceMappingURL=request.js.map
